import { Band } from "../../bravoTypes";


export const setBand = (band:Band) => ({
    type: "band.set", 
    payload: band
});

export type BandAction = ReturnType<typeof setBand>;

